import dynamic from 'next/dynamic';

const esadirComponents = {

    Actualitat: { dynamicComponent: dynamic(() => import(`components/esadir/Actualitat`)) },
    Capcalera: { dynamicComponent: dynamic(() => import(`components/corporatiu/Menu`)) },
    Cercador: { dynamicComponent: dynamic(() => import(`components/esadir/Cercador`)) },
    Columna: { dynamicComponent: dynamic(() => import(`components/corporatiu/Columna`)) },
    Compartir: { dynamicComponent: dynamic(() => import(`components/esadir/Compartir`)) },
    Contenidor: { dynamicComponent: dynamic(() => import(`components/corporatiu/Contenidor`)) },
    ContingutEstatic: { dynamicComponent: dynamic(() => import(`components/esadir/ContingutEstatic`)) },
    ContingutsMovil: { dynamicComponent: dynamic(() => import(`components/esadir/ContingutsMovil`)) },
    Destacat: { dynamicComponent: dynamic(() => import(`components/esadir/Destacat`)) },
    Enllac: { dynamicComponent: dynamic(() => import(`components/corporatiu/Enllac`)) },
    EtiquetesToponim: { dynamicComponent: dynamic(() => import(`components/esadir/EtiquetesToponim`)) },
    Fila: { dynamicComponent: dynamic(() => import(`components/corporatiu/Fila`)) },
    FilAriadna: { dynamicComponent: dynamic(() => import(`components/esadir/FilAriadna`)) },
    Header: { dynamicComponent: dynamic(() => import(`components/esadir/Header`)) },
    Imatge: { dynamicComponent: dynamic(() => import(`components/esadir/Imatge`)) },
    ItemMock: { dynamicComponent: dynamic(() => import(`components/esadir/ItemMock`)) },
    LlistaAnysFilmoteca: { dynamicComponent: dynamic(() => import(`components/esadir/LlistaAnysFilmoteca`)) },
    LlistaEnllacos: { dynamicComponent: dynamic(() => import(`components/esadir/LlistaEnllacos`)) },
    Paginador: {dynamicComponent: dynamic(() => import(`components/esadir/Paginador`))},
    ResultatsCercaEsadir: { dynamicComponent: dynamic(() => import(`components/esadir/ResultatsCercaEsadir`)) },
    Menu: { dynamicComponent: dynamic(() => import(`components/esadir/Menu`)) },
    Pellicules: { dynamicComponent: dynamic(() => import(`components/esadir/Pellicules`)) },
    Metadades: { dynamicComponent: dynamic(() => import(`components/esadir/Metadades`)) },
    Peu: { dynamicComponent: dynamic(() => import(`components/corporatiu/Peu`)) },
    PeuEsadir: { dynamicComponent: dynamic(() => import(`components/esadir/PeuEsadir`)) },
    Subtitol: { dynamicComponent: dynamic(() => import(`components/esadir/Subtitol`)) },
    Text: { dynamicComponent: dynamic(() => import(`components/esadir/Text`)) },
    Titol: { dynamicComponent: dynamic(() => import(`components/corporatiu/Titol`)) },
    UltimsCanvis: { dynamicComponent: dynamic(() => import(`components/esadir/UltimsCanvis`)) },
    
};

export { esadirComponents };
